// UX P1 R1 — sunucu bu alana yazımımızı atladı (aynı kullanıcının daha yeni değeri vardı:
// başka sekme/cihaz ya da sırası karışmış geç istek) ve sunucudaki değer gönderdiğimizden
// farklı. Sessiz "Kaydedildi" yerine kartta bildirim; kullanıcının yazdığı değer kaybolmaz —
// "Benimkini uygula" saklı damganın üstünde taze damgayla yeniden gönderir.
// Müşteri yüzeyinde de görünür: kopya FORM_SAVE_COPY (AI/üretim/danışman notu yok).

import { formatFormValue, type QuestionSnapshot } from "@mahir/shared";
import { useFormFillStore } from "../../stores/form-fill-store";
import { FORM_SAVE_COPY as C } from "../../lib/form-save-copy";

export function SupersededNotice({ question }: { question: QuestionSnapshot }): JSX.Element | null {
  const notice = useFormFillStore((s) => s.supersededByCode[question.code]);
  const applyMine = useFormFillStore((s) => s.applySupersededMine);
  const dismiss = useFormFillStore((s) => s.dismissSuperseded);
  if (!notice) return null;
  return (
    <div
      role="status"
      data-testid="superseded-notice"
      className="mt-2 px-3 py-2 rounded-lg text-xs"
      style={{
        background: "var(--color-warning-bg)",
        border: "1px solid var(--color-warning-border)",
        color: "var(--color-warning-text)",
      }}
    >
      <div style={{ fontWeight: 600 }}>{C.supersededCard}</div>
      <div className="mt-1">
        {C.supersededMine(formatFormValue(notice.mine, question, { emptyText: "—" }))}
      </div>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          onClick={() => applyMine(question.code)}
          className="px-2 py-1 rounded"
          style={{ background: "var(--color-primary)", color: "var(--color-surface)" }}
        >
          {C.supersededApplyMine}
        </button>
        <button
          type="button"
          onClick={() => dismiss(question.code)}
          className="px-2 py-1 rounded"
          style={{
            background: "transparent",
            border: "1px solid var(--color-border)",
            color: "var(--color-text-2)",
          }}
        >
          {C.supersededKeep}
        </button>
      </div>
    </div>
  );
}
